import { render, staticRenderFns } from "./PercentageMovement.vue?vue&type=template&id=46ca38c6&scoped=true&"
import script from "./PercentageMovement.vue?vue&type=script&lang=js&"
export * from "./PercentageMovement.vue?vue&type=script&lang=js&"
import style0 from "./PercentageMovement.vue?vue&type=style&index=0&id=46ca38c6&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ca38c6",
  null
  
)

export default component.exports